import httpClient from './httpClient'

export default {
  getAll(status) {
    return httpClient.get(`dossiers/${status}`).then(r => r.data)
  },
  get(id) {
    return httpClient.get(`dossiers/${id}`).then(r => r.data)
  },
  updateStatus(id, statusCode) {
    return httpClient.put(`dossiers/${id}/${statusCode}`).then(r => r.data)
  },
  recall(id) {
    return httpClient.put(`dossiers/${id}/recalled`).then(r => r.data)
  },
  remove(ids) {
    return httpClient.delete(`dossiers?ids=${ids}`).then(r => r.data)
  },
  removeById(id) {
    return httpClient.delete(`dossiers?id=${id}`).then(r => r.data)
  }
}
